/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { orderConfirmationForm } from "../../../../api/Api";

export const getAllOrderConfirmationForm = createAsyncThunk(
  "appOrderConfirmationForm/getAllOrderConfirmationForm",
  async () => {
    try {
      return orderConfirmationForm.getAll();
    } catch (error) {
      console.error(error);
    }
  }
);

export const getOrderConfirmationForm = createAsyncThunk(
  "appOrderConfirmationForm/getOrderConfirmationForm",
  async (id) => {
    try {
      return orderConfirmationForm.getOrderConfirmationForm(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const addOrderConfirmationForm = createAsyncThunk(
  "appOrderConfirmationForm/addOrderConfirmationForm",
  async (values) => {
    try {
      return orderConfirmationForm.create(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteOrderConfirmationForm = createAsyncThunk(
  "appOrderConfirmationForm/deleteOrderConfirmationForm",
  async (id) => {
    return orderConfirmationForm.deleteItem(id);
  }
);

export const editOrderConfirmationForm = createAsyncThunk(
  "appOrderConfirmationForm/editOrderConfirmationForm",
  async (values) => {
    return orderConfirmationForm.edit(values);
  }
);

export const appOrderConfirmationFormSlice = createSlice({
  name: "appOrderConfirmationForm",
  initialState: {
    orderConfirmationForm: [],
    isFetchedOrderConfirmationForm: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllOrderConfirmationForm.fulfilled, (state, action) => {
        state.orderConfirmationForm = action.payload?.data?.data;
        state.isFetchedOrderConfirmationForm = true;
      })
      .addCase(deleteOrderConfirmationForm.fulfilled, (state, action) => {
        state.isFetchedOrderConfirmationForm = false;
      })
      .addCase(editOrderConfirmationForm.fulfilled, (state, action) => {
        state.isFetchedOrderConfirmationForm = false;
      })
      .addCase(addOrderConfirmationForm.fulfilled, (state, action) => {
        state.isFetchedOrderConfirmationForm = false;
      });
  },
});

export default appOrderConfirmationFormSlice.reducer;
